import { InfoIcon } from 'lucide-react';

import { Icon, Inline } from '@crossnokaye/ux-common';

export const ModeNotice = () => {
  return (
    <Inline className="gap-x-2">
      <Icon icon={InfoIcon} variant="transparent" color="stroke-ckds-neutral-500" size="sm" />
      <span className="text-sm">
        This evaporator’s Defrost Mode setting must be set to Auto_Schedule in order for schedule
        changes to take effect.
      </span>
    </Inline>
  );
};
